import script from "./ConfirmField.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmField.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmField.vue?vue&type=style&index=0&id=1f0d44cc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f0d44cc"]])

export default __exports__